module.exports = __webpack_public_path__ + "img/1035.502ff1ac.gif";